import checkboxStyles from "../../../styles/UI/checkbox.module.css"
import { ReactComponent as CheckIcon } from "../../../assets/icons/check_white.svg"

const Checkbox = ({ checked, onChange }: { checked: boolean, onChange: (isGroup: boolean) => void }) => {

    return (
        <label className="flex cursor-pointer">
            <input
                className={checkboxStyles.nativeCheckbox}
                checked={checked}
                type="checkbox"
                onChange={(e) => onChange(e.target.checked)}
            />
            <span className={checkboxStyles.checkbox}>
                {checked && <CheckIcon />}
            </span>
        </label>
    )
}

export default Checkbox

